import api from '@pray/shared/utils/api';

import type { WarmupAudienceOption } from './types';

export async function getArtistWarmupAudienceOptions({
  artistId,
}: {
  artistId: string;
}): Promise<{ audiences: WarmupAudienceOption[] }> {
  if (!artistId) throw new Error('Artist ID is required');
  const url = `/web/studio/artists/${artistId}/warmup-campaigns/audience-options`;
  const response = await api.executeGetRequest<{ data: { audiences: WarmupAudienceOption[] } }>(url);
  return response.data.data;
}
